export const ASSETS_URL = "https://assets.devowl.io/in-app/wp-real-cookie-banner/";
export * from "./forms";
export * from "./lists";
export * from "./common";
export * from "./templateCenter";
export * from "./upsell";
export * from "./scanner";
